import { Tabs } from "@jana-technology/platform-ui";
import { RISK_ROUTE_CHARTS, RISK_ROUTE_TABLES } from "constants/routing";
import { useGlobalFiltersContext } from "contexts/filters/global-filters";
import { useRiskManagementFiltersContext } from "contexts/filters/risk-management-filters";
import { useOutcomeScenariosContext } from "contexts/scenarios";
import { getRiskChartsPath, parseWellIdNameParam } from "helpers/routing";

import { useNavTabsFromHandle } from "hooks/useNavTabsFromHandle";
import { generatePath } from "react-router-dom";

export const RiskManagementNavTabs = () => {
  const { primaryTabs, secondaryTabs, primaryDefaultTab, secondaryDefaultTab } =
    useNavTabsFromHandle();

  const { wellIdNameParam } = useGlobalFiltersContext();
  const { appliedRiskMitigationId, chartsView } =
    useRiskManagementFiltersContext();

  const { selectedScenario } = useOutcomeScenariosContext();
  const [hierarchyId, wellName] = parseWellIdNameParam(wellIdNameParam);

  // for now, only show outcome scenarios when a risk mitigation is not applied

  return primaryTabs ? (
    <div className="flex justify-between">
      <div className="flex">
        <Tabs
          asNav
          className="uppercase"
          items={primaryTabs.map((tab) => {
            if (tab.link?.includes(RISK_ROUTE_CHARTS)) {
              // does not preserve /major/ route on unmount; not sure if needed yet
              return {
                ...tab,
                link: getRiskChartsPath(hierarchyId, wellName, chartsView),
              };
            }

            // data table
            return {
              ...tab,
              link: generatePath(
                `${RISK_ROUTE_TABLES}/${selectedScenario ?? ""}`,
              ),
            };
          })}
          value={primaryDefaultTab}
        />
      </div>
      {secondaryTabs && !appliedRiskMitigationId && (
        <Tabs
          asNav
          kind="secondary"
          items={secondaryTabs}
          value={secondaryDefaultTab}
        />
      )}
    </div>
  ) : null;
};

export default RiskManagementNavTabs;
